import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { ExtrasStep } from './ExtrasStep';
import { ExtrasProps, ExtrasStepStoreProps } from './ExtrasStep.types';
import { multiRoomRateBookingFormConfig, roomRateBookingFormConfig } from '../../shared';
import { yourJourneySelectors } from '@store/yourJourney/selectors';

const mapStateToProps = (state): ExtrasStepStoreProps => ({
  selectedExtras: formValueSelector(roomRateBookingFormConfig.form)(state, 'extras'),
  multiRoomSelectedExtras: formValueSelector(multiRoomRateBookingFormConfig.form)(state, 'extras'),
  areGuestsLoaded:
    !!formValueSelector(roomRateBookingFormConfig.form)(state, 'guests') ||
    !!formValueSelector(multiRoomRateBookingFormConfig.form)(state, 'guests'),
  guests: formValueSelector(multiRoomRateBookingFormConfig.form)(state, 'guests'),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

const ExtrasStepForm = reduxForm<{}, ExtrasProps>({
  ...roomRateBookingFormConfig,
})(ExtrasStep);

const MultiRoomExtrasStepForm = reduxForm<{}, ExtrasProps>({
  ...multiRoomRateBookingFormConfig,
})(ExtrasStep);

export const ExtrasStepContainer: any = connect(mapStateToProps)(ExtrasStepForm);
export const MultiRoomExtrasStepContainer: any = connect(mapStateToProps)(MultiRoomExtrasStepForm);
